import { BfIconChevronLeft, BfIconChevronRight } from './BfIcons';

/** Стрелки ‹ › по краям горизонтальной ленты; видны только на десктопе (CSS) и только когда есть куда листать. */
export default function BfHScrollArrows({ edges, onStep }) {
  const step = (dir) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    onStep(dir);
  };
  return (
    <>
      <button
        type="button"
        className="bf-hscroll__arrow bf-hscroll__arrow--prev"
        data-show={edges.start ? 'true' : 'false'}
        tabIndex={-1}
        aria-hidden="true"
        onPointerDown={(e) => e.stopPropagation()}
        onClick={step(-1)}
      >
        <BfIconChevronLeft />
      </button>
      <button
        type="button"
        className="bf-hscroll__arrow bf-hscroll__arrow--next"
        data-show={edges.end ? 'true' : 'false'}
        tabIndex={-1}
        aria-hidden="true"
        onPointerDown={(e) => e.stopPropagation()}
        onClick={step(1)}
      >
        <BfIconChevronRight />
      </button>
    </>
  );
}
